import { ReactNode } from 'react';

export function SuccessToast({ message }: { message: string | ReactNode }) {
  return (
    <div data-testid="success-message">
      <b>Success! </b>
      {message}
    </div>
  );
}

export function ErrorToast({ message }: { message: string | ReactNode }) {
  return (
    <div data-testid="error-message">
      <b>Error! </b>
      {message}
    </div>
  );
}
